<script>
import {defineComponent} from "vue";
import {getMimeTypeFromExtension} from "@/components/graphics/Graphics";
import {isArray} from "lodash";
import VideoElement from "@/components/graphics/VideoElement.vue";
import AdvImageElement from "@/components/graphics/AdvImageElement.vue";


export default defineComponent({
	name: "Graphic",
	props: {
		src: {
			type: [String, Array],
			default: null
		},
		type: {
			type: String,
			default: "static"
		},
		loop: {
			type: Boolean,
			default: false
		},
		autoplay: {
			type: Boolean,
			default: false
		},
		loopCount: {
			type: Number,
			default: 0
		},
		muted: {
			type: Boolean,
			default: false
		},
		playsinline: {
			type: Boolean,
			default: true
		},
		delay: {
			type: Number,
			default: 0
		},
		isVisible: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		sources() {
			if (!this.src) return null;
			return isArray(this.src) ? this.src : [this.src];
		},
		mime() {
			const original = isArray(this.src) ? this.src[0] : this.src;
			return getMimeTypeFromExtension(original);
		},
		graphicType() {
			if (this.mime && this.mime.includes("video")) return "video";
			return "image";
		},
		props() {
			const sources = this.sources;
			const src = (this.type === "static" || this.graphicType === 'image') ? sources[0] : null;
			return {
				...this.$props,
				sources,
				src
			};
		},
		comp() {
			if (this.graphicType === "video") return VideoElement;
			return AdvImageElement;
		}
	},
	methods: {
		start() {
			this.$refs?.graphic?.start();
		},
		pause() {
			this.$refs?.graphic?.pause();
		}
	}

});

</script>

<template>
	<component :is="comp" ref="graphic" v-bind="props"/>
</template>

